import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import log from '@atlassian/jira-common-util-logging/src/log';
import type { EstimationConfig } from '../../model/types';
import fetchEstimationConfig from '../../services/estimation-config';
import {
	FETCH_ESTIMATION_CONFIG,
	fetchEstimationConfigSuccess,
	fetchEstimationConfigFailure,
} from '../../state/actions/estimation-config';
import type { ActionsObservable, MiddlewareAPI } from '../../state/types';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (action$: ActionsObservable, store: MiddlewareAPI) =>
	action$
		.ofType(FETCH_ESTIMATION_CONFIG)
		.switchMap(() => fetchEstimationConfig(store))
		.map((estimationConfig: EstimationConfig) => fetchEstimationConfigSuccess(estimationConfig))
		.catch((error) => {
			log.safeErrorWithoutCustomerData(
				'software-reports.velocity-report.failure',
				'Failed to load estimation config',
				error,
			);
			return Observable.of(fetchEstimationConfigFailure());
		});
